import Notes from '../index';

const routes = [
  {
    path: '',
    component: Notes
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/apps/bpm/notes/router/routes.js